module.exports = __webpack_public_path__ + "static/media/background.688b0512.svg";